import React, { FC } from 'react';
import { paths } from 'routing';
import { NewsletterListPage } from 'pages/NewsletterPage/NewsletterListPage';
import { NewsletterEditPage } from 'pages/NewsletterPage/NewsletterEditPage';
import { IndexPage } from 'pages/common/IndexPage';

export const NewsletterPage: FC = () => (
  <IndexPage
    listPath={paths.NEWSLETTER_LIST}
    editPath={paths.NEWSLETTER_EDIT}
    newPath={paths.NEWSLETTER_NEW}
    listComponent={NewsletterListPage}
    editComponent={NewsletterEditPage}
  />
);
